// extracted by mini-css-extract-plugin
export default {"card":"SavedFilters_card__Pdcua"};